import api from "./api";
import { APIs } from "../constants/APIConstants";

export default class JoinMeetingAPIFunction {
    joinMeeting(req) {
        return api.post(APIs.JOIN_MEETING.replace("{SessionId}", req.sessionId), req);
    }

    sendDeviceInformationApi(req) {
        return api.put(APIs.SEND_DEVICE_INFORMATION.replace("{SessionId}", req.sessionId), req);
    }
}
